//RatingBar
export const BAR_RATING = [
  {
    text: "Rating is displayed using ",
    code: "#react-rating",
  },
  {
    text: " id using react",
  },
];

export const STAR_RATING = [
  {
    text: "Star rating is displayed using ",
    code: "#react-rating ",
  },
  {
    text: "id using react.",
  },
];

export const REVERSED_RATING = [
  {
    text: "Reversed rating is displayed using ",
    code: "#direction  ",
  },
  {
    text: "attribute using react.",
  },
];

export const FILL_COLOR = ["#f14f45", "#f14f45", "#f16c45", "#f17a45", "#f18845", "#f19745", "#f1b345", "#f1c245", "#f1d045", "#f1de45"];

export const TOOLTIP_ARRAY = ["Terrible", "Terrible+", "Bad", "Bad+", "Average", "Average+", "Great", "Great+", "Awesome", "Awesome+"];

export const TOOLTIP_RATING = [
  {
    text: "Tooltip rating is displayed using ",
    code: "#showTooltip  ",
  },
  {
    text: "attribute using react.",
  },
];

export const THUMBS_RATING = [
  {
    text: "Thumb rating is displayed using ",
    code: ".fa-thumbs-up & .fa-thumbs-down",
  },
  {
    text: " class in rating symbol",
  },
];

export const CURRENT_RATING = [
  {
    text: "Star rating is displayed using ",
    code: "#react-simple-star-rating",
  },
  {
    text: " and reset rating",
  },
];